module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-2_MT-ab00ee625f7b3d7eb0778067e7df2538.svg";